export default () => ({
  consentStatus: null,
  preferences: {
    necessary: true,
    analytics: false,
    advertising: false,
    functional: false
  },

  bannerVisible: true,
  lastUpdated: null
})
